export { GlobalStylesProvider, PLATFORM_COOKIE, REBRAND_COOKIE, useTheme, } from './GlobalStylesProvider';
//# sourceMappingURL=index.js.map
// @zapier/global-styles-provider@0.5.3 (3a3e46256)
